import ContactUs from "../components/layout/contact-us/ContactUs";

const ContactUsPage = (props) => {
  return <ContactUs content={props.content} />;
};

export default ContactUsPage;
